export default __webpack_public_path__ + "static/media/spinner.0afb0121.gif";